import MessageFiles from './MessageFiles.component';

export default MessageFiles;